import * as fb from '@/firebase';

export class UserProfile {
  public static fromFirebaseDoc(
    id: string,
    doc: firebase.firestore.DocumentData
  ): UserProfile {
    const profile = new UserProfile();
    profile.id = id;
    profile.bio = doc.bio;
    profile.username = doc.username;
    profile.homepage = doc.homepage;
    profile.displayName = doc.displayName;
    profile.photoURL = doc.photoURL;
    profile.numFollowers = doc.numFollowers;
    profile.numFollowing = doc.numFollowing;
    profile.numPublicLists = doc.numPublicLists;
    profile.joinDate = new Date(doc.joinDate);
    profile.isAdmin = doc.isAdmin as boolean;
    profile.inviteCodeId = doc.inviteCodeId;
    return profile;
  }

  public static empty(): UserProfile {
    const profile = new UserProfile();
    profile.id = null;
    profile.bio = null;
    profile.username = null;
    profile.homepage = null;
    profile.displayName = null;
    profile.photoURL = null;
    profile.numFollowers = 0;
    profile.numFollowing = 0;
    profile.numPublicLists = 0;
    profile.joinDate = null;
    profile.isAdmin = false;
    profile.inviteCodeId = null;
    return profile;
  }

  public id: string;
  public bio: string;
  public username: string;
  public homepage: string;
  public displayName: string;
  public photoURL: string;
  public numFollowing: number;
  public numFollowers: number;
  public numPublicLists: number;
  public joinDate: Date;
  public isAdmin: boolean;
  public inviteCodeId: string;

  public toFirebaseDoc(): any {
    return {
      displayName: this.displayName,
      bio: this.bio,
      homepage: this.homepage,
      username: this.username,
      photoURL: this.photoURL,
      numFollowers: this.numFollowers || 0,
      numFollowing: this.numFollowing,
      numPublicLists: this.numPublicLists,
      joinDate: this.joinDate.getTime(),
      isAdmin: this.isAdmin || false,
      inviteCodeId: this.inviteCodeId || null
    };
  }

  get link() {
    return `https://www.mixlet.com/u/${this.username}`;
  }

  public get firebaseConsoleLink() {
    return `https://console.firebase.google.com/project/${fb.firebaseConfig.projectId}/database/firestore/data~2F${fb.usersCollection.id}~2F${this.id}`;
  }
}